import React, { useContext, useEffect, useState } from 'react'
import { Spin, Empty, Tree, Space, Button, Affix, Form, Modal, App } from 'antd'
import { FaPlus, FaEdit, FaTrash } from "react-icons/fa";
import _ from "lodash"
import { API, Enum } from "../../../resources/constants"
import language from "../../../resources/languages/fa_IR"

// Contexts
import AxiosContext from "../../../contexts/axios";

// Interfaces
import { AxiosError } from "../../../interfaces/axios"
import type { DataNode } from 'antd/es/tree';

// Components
import CUDirectory from "./cu-directory"

enum CUEnum {
    Add = "ADD",
    Edit = "Edit"
}
const { Pages: { FileManagement: { Directory: DirectoryLanguage } }, Message: MessageLanguage, Share } = language
const {  FILE_MANAGEMENT_DIRECTORY_ALL, FILE_MANAGEMENT_DIRECTORY_REMOVE } = API
const { Message } = Enum

export default function Index() {

    const [, forceUpdate] = useState({})
    const [form] = Form.useForm()
    const [loadingRecords, setLoadingRecords] = useState<boolean>(false)
    const [categories, setCategories] = useState<DataNode[]>([])
    const [selected, setSelected] = useState<DataNode|null>(null)
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false)
    const [modalType, setModalType] = useState<CUEnum>(CUEnum.Add)
    const { axios } = useContext(AxiosContext)
    const { message, modal } = App.useApp();

    const getCategories = () => {
        setLoadingRecords(true)
        axios.post(FILE_MANAGEMENT_DIRECTORY_ALL).then((response: { data: [] }) => {
            const { data: categories } = response
            setCategories(filter(categories))
            setLoadingRecords(false)
        }).catch((error: AxiosError) => {
            const { response: { data } } = error;
            // @ts-ignore
            message.error(MessageLanguage[data.message]).then(response => response )
            setLoadingRecords(false)
        })
    }

    const filter = (categories: []) => {
        for (let i = 0; i < categories.length; ++i) {
            categories[i]['key'] = categories[i]['id']
            categories[i]['value'] = categories[i]['id']
            categories[i]['title'] = categories[i]['title']
            if (!_.isEmpty(categories[i]['children'])) filter(categories[i]['children'])
        }
        return categories
    }

    const onSelect = (selectedKeys: React.Key[], info: any) => {
        const { node, selected } = info
        selected ? setSelected(node) : setSelected(null)
    };

    useEffect(() => {
        // To disable submit button at the beginning.
        forceUpdate({})
        getCategories()
    }, []);

    return (
        <Spin spinning={loadingRecords} tip={Share.loading} size="large">
            <Modal destroyOnClose={true} title={modalType === CUEnum.Add ? Share.addRecord : Share.editRecord} cancelText={Share.cancel} okText={Share.save} open={isModalOpen} onOk={() => form.submit()} onCancel={() => {
                setModalType(CUEnum.Add)
                setIsModalOpen(false)
            }}>
                <CUDirectory Form={Form} form={form} getCategories={getCategories} Categories={categories} Directory={selected} type={modalType} />
            </Modal>
            {
                !_.isEmpty(categories) ? (
                    <>
                        <Tree
                            showLine={true}
                            defaultExpandAll={true}
                            onSelect={onSelect}
                            treeData={categories}
                        />
                        <br />
                        <Affix offsetBottom={30}>
                            <Space.Compact block>
                                <Button type="primary" key='add' icon={<FaPlus />} onClick={() => setIsModalOpen(true)}>{ Share.add }</Button>
                                <Button key='edit' icon={<FaEdit />} onClick={() => {
                                    if (_.isNull(selected)) modal.info({
                                        title: Share.pleaseSelectedRecord,
                                    }); else {
                                        setModalType(CUEnum.Edit)
                                        setIsModalOpen(true)
                                    }
                                }}>{ Share.edit }</Button>
                                <Button type="primary" key='delete' danger icon={<FaTrash />} onClick={() => {
                                    if (_.isNull(selected)) modal.info({
                                        title: Share.pleaseSelectedRecord,
                                    }); else modal.confirm({
                                        title: Share.deleteConfirmTitle,
                                        okText: Share.deleteConfirmOk,
                                        okType: 'danger',
                                        cancelText: Share.deleteConfirmCancel,
                                        onOk() {
                                            setLoadingRecords(true)
                                            const { key } = selected;
                                            axios.delete(FILE_MANAGEMENT_DIRECTORY_REMOVE + key).then((response: {}) => {
                                                getCategories()
                                                message.success(MessageLanguage[Message.DELETE_RECORD]).then(response => response)
                                            }).catch((error: AxiosError) => {
                                                const { response: { data } } = error;
                                                // @ts-ignore
                                                message.error(MessageLanguage[data.message]).then(response => response )
                                                setLoadingRecords(false)
                                            })
                                        }
                                    })
                                }}>{ Share.delete }</Button>
                            </Space.Compact>
                        </Affix>
                    </>
                ) : (
                    <>
                        <Empty description={DirectoryLanguage.empty} />
                        <br />
                        <Affix offsetBottom={30}>
                            <Space.Compact block>
                                <Button type="primary" key='add' icon={<FaPlus />} onClick={() => setIsModalOpen(true)}>{ Share.add }</Button>
                            </Space.Compact>
                        </Affix>
                    </>
                )
            }
        </Spin>
    )
}
